"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapCartProductToProduct = void 0;
const mapCartProductToProduct = (product) => ({
    id: product.id,
    url: product.url,
    trackingName: product.trackingName,
    manufacturerSku: product.manufacturerSku,
    trackingPath: product.trackingPath,
    price: product.price,
    originalPrice: product.originalPrice,
    title: product.title,
    participants: {
        min: product.minParticipants,
        max: product.maxParticipants,
    },
    discountBadgeId: product.discountBadgeId,
    discountBadgeName: product.discountBadgeName,
    hasFriendsDiscount: product.hasFriendsDiscount,
});
exports.mapCartProductToProduct = mapCartProductToProduct;
//# sourceMappingURL=mapCartProductToProduct.js.map